import type { FC } from 'react';

import { SpeechIcon } from '@motorway/mw-highway-code';
import { Chip } from '@motorway/mw-highway-code/pre-alpha';

import { useConversationSidebarMobile } from 'Features/AiCompanion';

import styles from './VehicleListV2.module.scss';

export const ConversationChip: FC = () => {
	const handleOpen = useConversationSidebarMobile((s) => s.open);

	return (
		<div className={styles.conversationChip}>
			<Chip data-testid="filter-chip-conversations" icon={SpeechIcon} label="" onClick={handleOpen} size="medium" />
		</div>
	);
};
